import { render } from "./CIS-ResourceRelatedResources.vue?vue&type=template&id=976c8386"
import script from "./CIS-ResourceRelatedResources.vue?vue&type=script&lang=js"
export * from "./CIS-ResourceRelatedResources.vue?vue&type=script&lang=js"

import "./CIS-ResourceRelatedResources.vue?vue&type=style&index=0&id=976c8386&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__